import { render, staticRenderFns } from "./EntityAddUpdate.vue?vue&type=template&id=4fc982ee&scoped=true"
import script from "./EntityAddUpdate.vue?vue&type=script&lang=ts"
export * from "./EntityAddUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc982ee",
  null
  
)

export default component.exports